import Axios from 'axios';
import { HttpError } from './http_error';

/**
 * Transforms an Axios error into our own HttpError.
 */
export function axiosEnhancedErrorAsHttpError<T>(error: unknown): HttpError<T> {
	if (Axios.isAxiosError(error)) {
		const httpError = new HttpError(error.message, error.response?.status ?? -1, error.response?.data ?? null);

		return httpError;
	}

	// If it's not an Axios Error, we have no idea how we ended up here. Return
	// the error and hope for the best.
	return error as never;
}
